import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'logged_out_retailers-logged_out_home_redesign_cta-click';
/**
 * track click event on logged out home (redesign)
parameter: 1. cta name 2. link
 */ export function trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(cta_name, link2) {
    var variant_string3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'CONTROL';
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            cta_name: cta_name,
            link2: link2,
            variant_string3: variant_string3
        }
    });
}
